function ExtendableError(...rest) {
  Error.apply(this, rest);
}
ExtendableError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
Object.setPrototypeOf(ExtendableError, Error);
export default ExtendableError;